module.exports = __webpack_public_path__ + "static/media/no-store.7c423163.png";